import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh-CN';
import enUS from './locales/en-US';

export type LocaleType = 'zh-CN' | 'en-US';

export const DEFAULT_LOCALE: LocaleType = 'en-US';
export const CN_LOCALE: LocaleType = 'zh-CN';
export const SUPPORTED_LOCALES: LocaleType[] = ['zh-CN', 'en-US'];

function normalizeLocale(locale?: string): LocaleType {
  if (!locale) {
    return DEFAULT_LOCALE;
  }
  const lower = locale.toLowerCase();
  if (lower.startsWith('zh')) {
    return 'zh-CN';
  }
  return 'en-US';
}

function getLocaleFromQuery(): LocaleType | null {
  const queryLang = new URLSearchParams(window.location.search).get('lang');
  if (!queryLang) {
    return null;
  }
  const locale = normalizeLocale(queryLang);
  return SUPPORTED_LOCALES.includes(locale) ? locale : null;
}

function getLocaleFromNavigator(): LocaleType | null {
  const locale = navigator.language || navigator.languages?.[0];
  if (!locale) {
    return null;
  }
  const normalized = normalizeLocale(locale);
  return SUPPORTED_LOCALES.includes(normalized) ? normalized : null;
}

function getCurrentLocale(): LocaleType {
  const fromQuery = getLocaleFromQuery();
  if (fromQuery) {
    return fromQuery;
  }
  const fromNavigator = getLocaleFromNavigator();
  if (fromNavigator) {
    return fromNavigator;
  }
  return DEFAULT_LOCALE;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: getCurrentLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
});

export default i18n;
